import { I18nextProvider as BaseI18nextProvider, type I18nextProviderProps } from 'react-i18next';

const I18nextProvider = (props: I18nextProviderProps & { children: React.ReactNode }) => {
  return <BaseI18nextProvider {...props} />;
};

export default I18nextProvider;
export type { I18nextProviderProps };
